export default __webpack_public_path__ + "static/media/pattern-iPattern2.bccdf76b.jpg";